import { Outlet } from "react-router-dom";
import { Menu } from "lucide-react";
import { BrandLogo } from "@/components/BrandLogo";
import { SidebarNav } from "@/components/layout/SidebarNav";
import { ThemeToggle } from "@/components/ThemeToggle";
import { ModeSwitcher } from "@/components/ModeSwitcher";
import { RoleSwitcher } from "@/components/RoleSwitcher";
import { UserMenu } from "@/components/UserMenu";
import { ProvenanceBadge } from "@/components/trust/ProvenanceBadge";
import { PlantStatusBadge } from "@/components/layout/PlantStatusBadge";
import { AskNiqPanel } from "@/components/askniq/AskNiqPanel";
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from "@/components/ui/sheet";

export function AppShell() {
  return (
    <div className="min-h-screen font-body" style={{ backgroundColor: "var(--oim-bg)", color: "var(--oim-text)" }}>
      <header
        className="fixed top-0 left-0 right-0 h-16 z-40 flex items-center justify-between px-4 lg:px-6 backdrop-blur-xl"
        style={{ borderBottom: "1px solid var(--oim-border)", backgroundColor: "var(--oim-bg-translucent)" }}
      >
        <div className="flex items-center gap-3">
          <Sheet>
            <SheetTrigger asChild>
              <button className="lg:hidden p-2" data-testid="mobile-menu-trigger">
                <Menu className="w-5 h-5" style={{ color: "var(--oim-text)" }} />
              </button>
            </SheetTrigger>
            <SheetContent side="left" className="bg-[var(--oim-surface)] border-[var(--oim-border)] w-64 p-0 pt-4">
              <SheetTitle className="sr-only">Navigation menu</SheetTitle>
              <div className="px-4 mb-4"><BrandLogo testId="brand-logo-mobile" /></div>
              <SidebarNav />
            </SheetContent>
          </Sheet>
          <BrandLogo testId="brand-logo-header" />
          <ProvenanceBadge />
          <PlantStatusBadge />
        </div>
        <div className="flex items-center gap-3">
          <ModeSwitcher />
          <RoleSwitcher />
          <ThemeToggle />
          <UserMenu />
        </div>
      </header>

      <aside className="hidden lg:flex fixed top-16 left-0 bottom-0 w-56 pt-4 flex-col" style={{ borderRight: "1px solid var(--oim-border)" }}>
        <SidebarNav />
      </aside>

      <main className="pt-16 lg:pl-56 min-h-screen">
        <div className="p-4 lg:p-6">
          <Outlet />
        </div>
      </main>

      <AskNiqPanel />
    </div>
  );
}
